module.exports = __webpack_public_path__ + "img/esim-grey.ab53c148.svg";